import styles from "./TopMenu.module.css";
import { AuthContext } from "../../Provider/AuthContext";
import { useContext, useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import OptionDropdown from "./OptionDropDown";
import Api from "../../services/Api";



function TopMenu({ leave }) {
  const { idTipoUsuario } = useContext(AuthContext);
  const [openMenu, setOpenMenu] = useState(false);
  const location = useLocation();
  const menuRef = useRef(null);
  const menuHamburguerRef = useRef(null);
  const opcoesMenu = JSON.parse(localStorage.getItem("menu"));

  const idTipoMenu = localStorage.getItem("tipoMenu");


  // Função para fechar o menu toda vez que a url mudar
  useEffect(() => {
    if (openMenu) {
      setOpenMenu(false);
    }
  }, [location]);

  // Fechar o menu quando clicar fora dele
  useEffect(() => {
    // Função que verifica se o clique foi fora do menu
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        menuHamburguerRef.current &&
        !menuHamburguerRef.current.contains(event.target)
      ) {
        setOpenMenu(false); // Fecha o menu se o clique foi fora
      }
    };

    // Adiciona o evento de clique no documento
    document.addEventListener("mousedown", handleClickOutside);

    // Limpa o evento ao desmontar o componente
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const home = [
    {
      title: "Home",
      icon: "fas fa-user",
      link: "/usina",
    },
  ];

  const dropdowns = [
    //Links que não entrarão no dropdown
    //Links do dropdown
    {
      title: "Cadastro",
      icon: "fas fa-user-plus",
      option: [
        {
          title: "Locais",
          icon: "fas fa-map",
          link: "/usina/local",
        },
        {
          title: "Prospecção",
          icon: "fas fa-map",
          link: "/usina/prospect",
        },
        // {
        //   title: "Embaixador",
        //   icon: "fas fa-chart-line",
        //   link: "/usina/embaixador",
        // },
        // {
        //   title: "Preposto",
        //   icon: "fas fa-chart-line",
        //   link: "/usina/preposto",
        // },
      ],
    },
    // {
    //   title: "Ligação",
    //   icon: "fas fa-phone-alt",
    //   option: [
    //     {
    //       title: "Painel de Ligação",
    //       icon: "fas fa-map",
    //       link: "/usina/painel-de-ligacao",
    //     },
    //     {
    //       title: "Dash Ligações",
    //       icon: "fas fa-map",
    //       link: "/usina/dash-ligacao",
    //     },
    //   ],
    // },

    {
      title: "Coletas",
      icon: "fas fa-plus",
      option: [
        {
          title: "Emissão de Coletas",
          icon: "fas fa-map",
          link: "/usina/emissao-de-coleta",
        },
        // {
        //   title: "Ocorrencia",
        //   icon: "fas fa-map",
        //   link: "/usina/ocorrencia",
        // },
      ],
    },

    {
      title: "Logística",
      icon: "fas fa-truck-pickup",
      option: [
        {
          title: "Relatório da Freguesia",
          icon: "fas fa-map",
          link: "/usina/logistica/criarota",
        },
        {
          title: "Painel da Freguesia",
          icon: "fas fa-map",
          link: "/usina/logistica/painel",
        },
      ],
    },

    //Links do dropdown que tem opções com dropdown
    {
      title: "Relatórios",
      icon: "fas fa-receipt",
      suboptions: [
        {
          subtitle: "Indicadores",
          suboption: [
            {
              title: "Indicador Geral",
              icon: "fas fa-map",
              link: "/usina/relario/indicador",
            },
            {
              title: "Indicador Por Segmento",
              icon: "fas fa-map",
              link: "/usina/relatorio/indicadorsegmento",
            },
          ],
        },
        // {
        //   subtitle: 'Geral',
        //   suboption: [
        //     {
        //       title: 'Locais',
        //       icon: 'fas fa-map',
        //       link: '/usina/',
        //     },
        //   ],
        // },
        // {
        //   subtitle: 'Operação',
        //   suboption: [
        //     {
        //       title: 'Usina',
        //       icon: 'fas fa-map',
        //       link: '/usina/',
        //     },
        //   ],
        // },
      ],
      option: [
        // {
        //   title: 'Indicador',
        //   icon: 'fas fa-map',
        //   link: '/usina/relario/indicador',
        // },
        {
          title: "Auditoria Motorista",
          icon: "fas fa-map",
          link: "/usina/relatorio/auditoriamotorista",
        },
      ],
    },
    {
      title: "Tabela",
      icon: "fas fa-table",
      suboptions: [
        {
          subtitle: "Config. Indicador",
          suboption: [
            {
              title: "Planejamento do Mês",
              icon: "fas fa-map",
              link: "/usina/planejamento/indicador",
            },
          ],
        },
        {
          subtitle: "Config. Tabelas Internas",
          suboption: [
            {
              title: "Material",
              icon: "fas fa-boxes",
              link: "/usina/material",
            },
            {
              title: "Grupo",
              icon: "fas fa-layer-group",
              link: "/usina/grupo",
            },
            {
              title: "Campanha",
              icon: "fas fa-chart-line",
              link: "/usina/campanha",
            },
            {
              title: "Brinde",
              icon: "fas fa-chart-line",
              link: "/usina/brinde",
            },
            {
              title: "Bombona",
              icon: "fas fa-chart-line",
              link: "/usina/bombona",
            },
            {
              title: "Estabelecimento",
              icon: "fas fa-clipboard-list",
              link: "/usina/estabelecimento",
            },

            {
              title: "Cidade",
              icon: "fas fa-chart-line",
              link: "/usina/cidade",
            },
            {
              title: "Preferencia Contato",
              icon: "fas fa-chart-line",
              link: "/usina/preferencia-contato",
            },

            {
              title: "Cadastrar Motorista",
              icon: "fas fa-chart-line",
              link: "/usina/cadastrar-motorista",
            },
            {
              title: "Tipo Logradouro",
              icon: "fas fa-chart-line",
              link: "/usina/tipo-logradouro",
            },
            {
              title: "Veiculos",
              icon: "fas fa-chart-line",
              link: "/usina/veiculo",
            },
          ],
        },
      ],
      option: [
        {
          // title: 'Material',
          // icon: 'fas fa-boxes',
          // link: '/usina/material',
        },
      ],
    },
    {
      title: "Segurança",
      icon: "fas fa-user",
      option: [
        {
          title: "Usuários",
          icon: "fas fa-user",
          link: "/usina/usuarios",
        },
        {
          title: "Perfil",
          icon: "fas fa-user",
          link: "/usina/perfil",
        },
        {
          title: "Ação",
          icon: "fas fa-boxes",
          link: "/usina/acao",
        },
      ],
    },
  ];

  function validateRouter() {
    if (idTipoMenu == 2) {
      return {
        home,
        opcoesMenu,
        dropdowns,
      };
    }
    return;
  }
  const routes = validateRouter();
  //
  return (
    <div className={styles.top_menu}>
      {/* Menu hamburguer */}
      <div
        className={styles.menu_sandwich}
        onClick={() => setOpenMenu(!openMenu)}
        ref={menuHamburguerRef}
      >
        <i className="fas fa-bars fa-4x" style={{ color: "#6d5e5e", fontSize: "2.5rem" }}></i>
      </div>
      <div
        className={`${styles.row} ${openMenu ? styles.open : ""}`}
        ref={menuRef}
      >
        <div className={styles.option}>
          <Link to="/usina">
            <i className="fas fa-home"></i>
            Home
          </Link>
        </div>
        {/** Dropdown */}

        {routes?.opcoesMenu?.map((values, index) => (
          <OptionDropdown
            key={index}
            menuUnico={values?.menuUnico}
            option={values.option}
            title={values.title}
            suboption={values.suboptions}
            icon={values.icon}
          />
        ))}

        {/** Links sem dropdown */}
        {routes?.links?.map((values, index) => (
          <div key={index} className={styles.option}>
            <Link to={values?.link}>
              <i className={values?.icon}></i>
              {values?.title}
            </Link>
          </div>
        ))}

        {/** Rotas genericas */}

        {/* <div className={styles.option} onClick={() => setOpenMenu(false)}>
          <Link
            to={{
              pathname: `https://api.whatsapp.com/send?phone=5511983279221&text=Olá,
              Necessito de um suporte`,
            }}
            target="_blank"
          >
            <i className="fab fa-whatsapp-square"></i>
            Suporte
          </Link>
        </div> */}
        <div className={styles.option}>
          <Link to="/" onClick={() => leave()}>
            <i className="fas fa-sign-out-alt"></i>
            Sair
          </Link>
        </div>
      </div>
    </div>
  );
}

export default TopMenu;
